import { useEffect, useState } from 'react'

import { makeVar } from '@apollo/client'
import classNames from 'classnames'

import { CommonWriteIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { setTopButtonBottomMargin } from '@web/components/TopButton/TopButton'
import useCheckinAccess from '@web/hooks/useCheckinAccess/useCheckinAccess'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { useGoTo } from '@web/hooks/useGoTo'
import useScroll from '@web/hooks/useScroll'
import { fromMissionQuery } from '@web/pages/mission/constants'

import styles from './CheckInButton.module.scss'

interface Props {
  clickCode: string
  Tooltip?: React.ReactElement
  fromMission?: boolean
}

const isFirstExposureVar = makeVar<boolean>(true)

const CheckInButton = ({ clickCode, Tooltip, fromMission }: Props) => {
  const isScrolled = useScroll((_: number, y: number) => y > 10)
  const [show, setShow] = useState(!isFirstExposureVar())
  const { isSsr } = useGlobalStaticStateContext()

  const { goToCheckIn } = useGoTo()

  const goToCheckin = () => {
    const extraQuery = fromMission ? { [fromMissionQuery.KEY]: fromMissionQuery.VALUE } : undefined
    goToCheckIn({ extraQuery })
  }

  const { validateAccess } = useCheckinAccess({ onSuccess: goToCheckin })

  useEffect(() => {
    setTopButtonBottomMargin(75)
    const timerId = setTimeout(() => {
      setShow(true)
      isFirstExposureVar(false)
    }, 50)

    return () => {
      clearTimeout(timerId)
      setTopButtonBottomMargin(null)
    }
  }, [])

  if (isSsr) return null

  return (
    <div
      className={classNames(styles.bottom_fixed_btn_area, {
        [styles.show]: show,
        [styles.type_collapse]: isScrolled,
      })}
    >
      <Clickable className={styles.btn_write_review} onClick={validateAccess} nClickCode={clickCode}>
        <CommonWriteIcon className={styles.icon} aria-hidden="true" />
        <span className={styles.name}>리뷰 쓰기</span>
      </Clickable>
      {isScrolled && Tooltip}
    </div>
  )
}

export default CheckInButton
